import React, { Component, Fragment } from 'react';

import { Redirect, withRouter } from 'react-router-dom';

import './index.css';
import ConnectedAccounts from './ConnectedAccounts';
import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import UberConnectModal from '../User/UberConnectModal';

class Connect extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.history.push('/downloadapp?type=link');
  }

  render() {
    const {
      history,
      status,
      loggedIn,
      uber_token,
      account_name,
      uber_password,
      email,
      connected_uber_email,
      location,
      operatingCity,
      rideshare_platforms
    } = this.props;
    const uberURL = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(email)}`;
    const message = location.state ? location.state.res : null;

    return (
      <Fragment>
        <div className="apply__progress--header">
          <Header
            title="My Profile"
            persistentTitle
            back
            disable
            onClick={() => history.goBack()}
          />
        </div>
        {!uber_token &&
        operatingCity === 'toronto' &&
        (status === 'operating' || status === 'autzu_active') ? (
          <UberConnectModal
            uberURL={uberURL}
            username={account_name}
            password={uber_password}
            message={message}
          />
        ) : (
          <Fragment>
            <div className="profile__body container">
              <div className="profile__container">
                <div className="profile__sidebar">
                  <SideBarContent status={status} signedIn={loggedIn} />
                </div>
                <div className="profile__user--container">
                  <div className="update-password__title">
                    Connected Account
                  </div>
                  <ConnectedAccounts
                    status={status}
                    connected_uber_email={connected_uber_email}
                    ridesharePlatforms={rideshare_platforms}
                  />
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default withRouter(Connect);



// WEBPACK FOOTER //
// ./src/components/Connect/index.js